import script from "./ModalGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalGroups.vue?vue&type=script&setup=true&lang=js"

import "./ModalGroups.vue?vue&type=style&index=0&id=7573b662&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7573b662"]])

export default __exports__